const gridPrePostRowRendererDirective = {
    restrict: 'A',
    scope: false,
    link: function (scope, element, attrs) {
        let cellElement = null;
        let transcludeFn = undefined;

        switch (attrs.ctxGridPrePostRowRenderer) {
            case 'pre-row': transcludeFn = scope.grid.preRow && scope.grid.preRow.transclude; break;
            case 'post-row': transcludeFn = scope.grid.postRow && scope.grid.postRow.transclude; break;
            default: throw 'ctxGridPrePostRowRenderer: No part name specified'
        }

        transcludeFn && transcludeFn(scope, clone => {
            if (attrs.ctxGridPrePostRowRenderer === 'post-row' && scope.grid.postRow && scope.grid.postRow.animateOnShow) {
                clone.addClass('ctx-slide-toggle');
            }
            element.append(clone);
            cellElement = clone;
        }, element);


        scope.getGridRowIndex = function () {
            return scope.$index;
        };
    }
};

module.exports = function () {
    return gridPrePostRowRendererDirective;
};



// WEBPACK FOOTER //
// ./src/shared/ctxGrid/ctxGridPrePostRowRenderer.directive.js